export const DOSSIERS_QUERY_KEY = "dossiers";

export type DossierStatus = "Open" | "Gesloten";
